import cn from '@/lib/clsxm';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Container from '@/components/@base/container';
import { ListItem } from '@/components/@base/list';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import Props from '@/components/app/product/components/@shared/highlight-item/type';

import imagesList from '@/constant/images-list';

export default function HighlightItem({ text, className }: Props) {
  return (
    <ListItem className={cn('border-b-[#F4F5F6] py-1', className)}>
      <Container center className='justify-start gap-2.5'>
        <XImage
          src={imagesList.icons.highlightItemIcon}
          alt='highlights'
          width={17}
          height={17}
        />
        <Text size={SIZE_ENUM.SM} className='truncate text-[#76767C]'>
          {text}
        </Text>
      </Container>
    </ListItem>
  );
}
